import { Icon, Icons } from '@silverfort/sf-components';
import { FC } from 'react';

interface Props {
    isAzureUser: boolean;
    isADUser: boolean;
}

const IDPColumn: FC<Props> = ({ isAzureUser, isADUser }) => {
    return (
        <div className="flex items-center gap-2">
            {isAzureUser && <Icon icon={Icons.IntegrationEntraID} size={20} />}
            {isADUser && <Icon icon={Icons.ActiveDirectory} size={20} />}
        </div>
    );
};

export default IDPColumn;
